// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || '';

// Canonical public origin of the voice runtime (wizard design dependency D3).
// Registration webhooks and the fallback-bundle stream URL derive from it —
// any other host form fails Twilio signature validation at the runtime.
export const VOICE_PUBLIC_ORIGIN =
  process.env.REACT_APP_VOICE_PUBLIC_ORIGIN?.replace(/\/$/, '') || '';

// Platform administration is a separate app with its own sign-in.
export const ADMIN_APP_URL = process.env.REACT_APP_ADMIN_URL || '';

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.waitingRoom;

//MAX IMAGE SIZE FOR UPLOADS
export const MAX_IMAGE_SIZE = parseInt(
  process.env.REACT_APP_MAX_IMAGE_SIZE ?? '3',
  10,
);

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 56,
  H_MOBILE_SEARCH: 64,
  H_NOTIFICATION_BAR: 50,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 64,
  H_TOOLBAR_DESKTOP: 64,
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 220,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
